<template>
  <div>
    <b-row class="text-center">
      <div v-if="!isAvailableData"></div>
      <div v-else-if="stats.saving>0" style="background: #00bfff;" class="savingdisplay">
        <h2 >【移動距離】年 {{ stats.saving }} km減   ({{ stats.savingRatio }} %減)</h2>
      </div>
      <div v-else                style="background: #fd8b8b;" class="savingdisplay">
        <h2>【移動距離】年 {{ -stats.saving }} km増   ({{ -stats.savingRatio }} %増)</h2>
      </div>
    </b-row>
    <b-row class="mt-2">
      <b-col cols="1">[km]</b-col>
      <b-col cols="5" class="text-center">
        <h4> R{{ String(gengo - 1) }}年度 </h4>
      </b-col>
      <b-col cols="5" class="text-center">
        <h4> R{{ String(gengo) }}年度 </h4>
      </b-col>
    </b-row>

    <div id="parent" class="parent">
      <Chart :chartData="stats.chartdata" :options="chartOptions" />
      <p v-show="isDisplay" class="text-center child previous"> {{ stats.subtotal_previous }} km</p>
      <p v-show="isDisplay" class="text-center child target"> {{ stats.subtotal_target }} km</p>
    </div>
  </div>
</template>

<script>
  import Chart from '@/components/modules/chart/bar_chart.js'
  export default {
    components: {
      Chart
    },
    props: {
      gengo :{
        type: Number,
        required: true,
      },
      stats: {
        type: Object,
        required: true,
      }
    },
    data() {
      return {
        isDisplay: true,
        // 後程オプションを記述
        chartOptions: {
          scales: {
            yAxes: [
              {
                ticks: {
                  fontSize: 16,
                }
              },
            ]
          },
//        maintainAspectRatio: false,
          legend: {
            position: 'bottom',
            labels:{
              fontSize: 14
            }
          },
          annotation: { 
            annotations: [
              { 
                type: 'line', // 線を描画
                id: 'vLine', 
                mode: 'vertical', // 線を水平に引く
                scaleID: 'x-axis-0', 
                value: 11.5, // 基準となる数値
                borderWidth: 1, // 基準線の太さ
                borderColor: 'gray'  // 基準線の色
              },
            ] 
          },
        }
      }
    },

    mounted() {
    },
    computed: {
      isAvailableData(){
        return this.stats.subtotal_previous > 0
      },
    },
    methods: {
      displaySubtotal(bool){
        this.isDisplay = bool
      },
    }
  }
</script>
<style scoped>
  .savingdisplay {
/*    background: #00bfff; */
    width: 80%;
    margin: 0 auto;
    padding: 3 4 2 4;
  }
  .parent {
    position: relative;
  }
  .child {
    position: absolute;
    color: white;
    background: #4169e1;
    opacity: 70%;
    width: 20%;
    bottom: 15%;
    font-size: 22px;
  }
  .previous {
    left: 16%;
  }
  .target {
    left: 66%;
  }
</style>
